<template>
  <div class="price-inquiry-detail">
    <div class="content">
         <!-- <el-empty description="暂无数据"></el-empty> -->
         	<el-form class="prod-form" label-width="140px" ref="priceIquiryForm" size="small" :model="formData">
        <div style="display:flex;align-items:center;padding:10px;box-shadow:0px 2px #eee">
            <el-button @click="goBack" style="margin-bottom:18px;">返回</el-button>
            <el-form-item  label="报价标题：" prop="quoteTitle">
                <el-input v-model="formData.quoteTitle"  type="text"  placeholder="请输入报价标题" style="width:250px;"></el-input>
            </el-form-item>
            <el-form-item label="报价公司名称">
                <div>{{createCompName||'--'}}</div>
            </el-form-item>
        </div>
        <div style="display: flex;align-items:center;">
            <div class="form-content">
               <el-card class="box-card">
                 <template #header>
                  <div class="header">
                    <span>交互信息</span>
                  </div>
                 </template>
                 <div>
                    <el-form-item label="交货产品名称型号" prop="deliveryProductNameModel">
                      <el-input v-model="formData.deliveryProductNameModel"  type="text" :readonly="true"  style="width:500px;"></el-input>
                    </el-form-item>
                 </div>
               <div style="display: flex;align-items:center;">
                <div>
                   <el-form-item label="数量" prop="quantity">
                    <el-input v-model="formData.quantity"  type="text" :readonly="true"  style="width:250px;"></el-input>
                    
                  </el-form-item>
                </div>
                <div>
                  <el-form-item label="单位" prop="unit">
                    <el-input v-model="formData.unit"  type="text" :readonly="true"  style="width:250px;"></el-input>
                  </el-form-item>
                </div>
               </div>
                <div style="display: flex;align-items:center;">
                <div>
                  <el-form-item label="交货时间" prop="deliveryTime">
                    <el-input v-model="formData.deliveryTime"  type="text" :readonly="true"  style="width:250px;"></el-input>
                  </el-form-item>
                   <el-form-item label="送货方式" prop="deliveryMethod">
                    <el-input v-model="formData.deliveryMethod"  type="text" :readonly="true"  style="width:250px;"></el-input>
                  </el-form-item>
                   <el-form-item label="质保条件" prop="qualityAssuranceConditions">
                    <el-input v-model="formData.qualityAssuranceConditions"  type="text" :readonly="true"  style="width:250px;"></el-input>
                  </el-form-item>
                </div>
                <div>
                  <el-form-item label="交货地点" prop="deliveryLocation">
                    <el-input v-model="formData.deliveryLocation"  type="text" :readonly="true"  style="width:250px;"></el-input>
                  </el-form-item>
                    <el-form-item label="包装" prop="packaging">
                    <el-input v-model="formData.packaging"  type="text" :readonly="true"  style="width:250px;"></el-input>
                  </el-form-item>
                   <el-form-item label="售后服务" prop="afterSalesService">
                    <el-input v-model="formData.afterSalesService"  type="text" :readonly="true"  style="width:250px;"></el-input>
                  </el-form-item>
                </div>
               </div>
              </el-card>
               <el-card class="box-card">
                <template #header>
                   <div class="header">
                    <span>质量验收与付款结算</span>
                  </div>
                </template>
               <div style="display: flex;align-items:center;">
                <div>
                  <el-form-item label="综合报价" prop="comprehensiveQuotation">
                    <el-input v-model="formData.comprehensiveQuotation"  type="text" :readonly="true"  style="width:250px;"></el-input>
                  </el-form-item>
                  <el-form-item label="付款方式" prop="paymentMethod">
                    <el-input v-model="formData.paymentMethod"  type="text" :readonly="true"  style="width:250px;"></el-input>
                  </el-form-item>
                </div>
                <div>
                  <el-form-item label="报价货币单位" prop="quotationUnit">
                    <el-input v-model="formData.quotationUnit"  type="text" :readonly="true"  style="width:250px;"></el-input>
                   
                  </el-form-item>
                   <el-form-item label="报价有效期" prop="quotationValidityPeriod">
                    <el-input v-model="formData.quotationValidityPeriod"  type="text" :readonly="true"  style="width:250px;"></el-input>
                   
                  </el-form-item>
                </div>
                <div>
                  <el-form-item label="是否含税" prop="isTaxIncluded">
                    <el-input v-model="formData.isTaxIncluded"  type="text" :readonly="true"  style="width:250px;"></el-input>
                   
                  </el-form-item>
                   <el-form-item label="税率" prop="taxRate">
                    <el-input v-model="formData.taxRate"  type="text" :readonly="true"  style="width:250px;"></el-input>
                   
                  </el-form-item>
                </div>
               </div>
              </el-card>
              <el-card class="box-card">
                <template #header>
                  <div class="header">
                    <span>附加信息与附件</span>
                  </div>
                </template>
                <div style="display: flex;align-items:center;"> 
                  <el-form-item label="联系人" prop="contactName">
                    <el-input v-model="formData.contactName"  type="text" :readonly="true"  style="width:250px;"></el-input>
                  </el-form-item>
                  <el-form-item label="联系电话" prop="contactPhone">
                    <el-input v-model="formData.contactPhone"  type="text" :readonly="true"  style="width:250px;"></el-input>
                  </el-form-item>
                </div>
               <div style="display: flex;align-items:center;">
                <div v-if="list.url" style="color:#409eff;">
                  <el-form-item label="上传报价附件">
                    <span style="margin-right:10px;line-height:20px;">
                       <el-link type="primary" :href="list.url">{{list.name}}</el-link>
                      <!-- <a >{{item.Name}}</span> -->
                    </span>
                  </el-form-item>
                </div>
                  
               </div>
              </el-card>
            </div>
        </div>
        </el-form>
    </div>
  </div>
</template>

<script>
import {PriceQuiryService,FileUploadObs,UtilService,SyncService, ApiService} from '@/service'




export default {
  data() {
    return {
      formData: {
        quoteTitle: '',
        deliveryProductNameModel:'',
        quantity:'',
        unit:'',
        deliveryTime:'',
        deliveryMethod:'',
        qualityAssuranceConditions:'',
        deliveryLocation:'',
        packaging:'',
        afterSalesService:'',
        comprehensiveQuotation:'',
        paymentMethod:'',
        quotationUnit:'',
        quotationValidityPeriod:'',
        isTaxIncluded:'',
        taxRate:'',
        contactName:'',
        contactPhone:'',
      },
      list:{name:'', url: ''},
      createCompName: '', // 报价公司名称
      inquiryInfo: {}, // 询价信息
      domain: ApiService.OssLook,
    }
  },
  components: {  },
  mounted() {
    this.inquiryInfo = this.$route.query;
    this.getEditInfo();
  },
  methods: {

    // 请求
    async getEditInfo() {
      const id = this.$route.query.id;
      const statusType = this.$route.query.statusType;
      const res = await PriceQuiryService.getQuoteInfo({id});
    //   const res = await PriceQuiryService.getInquiryDetail({id});
      if(res.data) {
        const keys = Object.keys(this.formData);
        for(let key of keys) {
          this.formData[key] = res.data[key] ||'';
        }
        const curName = res.data.annex?.fileName || '';
        const url = res.data.annex?.key ? `${this.domain}/${res.data.annex.key}` : '';
        this.list = {name:  curName, url: url};
        this.createCompName = res.data.createCompName || '';
      }
    },

    goBack() {
        history.go(-1)
        // this.$router.push({
        //   path: '/quotationInquiry/home'
        // });
    },

  }
}
</script>

<style lang="less" scoped>

.search-input{
  margin: 10px 0;
  width: 70%;
  min-width: 200px;
  
::v-deep .el-input__inner {
  height: 32px;
  line-height: 32px;
}
::v-deep .el-input-group__append button.el-button{
  color: #FFF;
  background-color: #409EFF;
  border-color: #409EFF;
  border-radius: 0;
}
}
.content {
    flex: 1;
    overflow-x: hidden;
    ::v-deep .el-form-item.width-name label.el-form-item__label {
    font-size: 16px ;
    font-weight: 600;
  }
  ::v-deep .el-card__header {
    background: #F5F5F5;
    padding: 10px 10px 10px 20px;
  }
  .footer {
    padding: 20px;
    text-align: right;
  }
}
.form-content {
  flex: 1;
  height: calc(100vh - 60px);
    overflow-y: auto;
}
.type-box {
  margin: 10px 0;
}
.tip-icon {
  font-size: 18px;
  color:#409EFF;
  margin-left:8px;
}

.price-inquiry-detail{
  display: flex;
  flex-direction: row;
  flex: 1;
  background: #ffffff;
  box-shadow: 0px 6px 20px 0px rgba(0, 0, 0, 0.1);
  ::v-deep .el-divider--horizontal{
    margin: 0;
  }
}
.width-name {
    .el-input {
        width: 500px;
    }
    
}
.box-card {
  // margin-top: 10px;
  width: 100%;
   width: 100%;
  ::v-deep .el-card__body {
    padding: 10px;
  }
}
.suplier-title {
  padding-left: 10px;
    margin-top: 10px;
    margin-bottom: 10px;
    height: 30px;
    line-height: 30px;
    background: #F5F5F5;
}
.checkbox-item {
  margin-bottom: 10px;

  ::v-deep .el-checkbox__label {
    white-space: nowrap;
    overflow: hidden;   
    text-overflow: ellipsis;
    width: 250px;
  }
}
.hide-upload-button ::v-deep div.el-upload--picture-card {
  display: none;
}

</style>
